<template>
    <v-flex xs12 >
        <div class="manage-chapter--wrapper" v-if="manageMyChaptersOptions && manageMyChaptersOptions.length">
          <v-card>
            <v-layout column wrap>
              <v-flex class="manage-chapter__title">{{communityCommonConstant.chapterAdmin.MANAGE_MY_CHAPTERS}}</v-flex>
              <v-layout column class="manage-chapter__options">
                <v-flex v-for="manageChapterOption in manageMyChaptersOptions" :key="manageChapterOption.id"
                        @click="navigateToManageChapterLink(manageChapterOption.link)"
                        class="manage-chapter__options--link"
                >
                  {{manageChapterOption.title}}
                </v-flex>
              </v-layout>
            </v-layout>
          </v-card>
        </div>
    </v-flex>
</template>

<script>
import { communityCommonConstant } from '../communityCommon.constant';
import { getManageMyChaptersOptions } from "@/components/ChapterPage/ChapterAdminView/ChapterAdminConstants";

export default {
    created() {
        const { communityId } = this.$route.params;
        this.manageMyChaptersOptions = getManageMyChaptersOptions(communityId);
    },
    data: () => ({
        communityCommonConstant,
        manageMyChaptersOptions: null,
    }),
    methods: {
        navigateToManageChapterLink(linkToNavigate) {
            if (this.isMobileAppBrowser) {
              window.open(linkToNavigate, '_self');
            } else {
              window.open(linkToNavigate, '_blank');
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../../common/styles/_colors.scss';
@import '../../../common/styles/_commonClasses.scss';

.forum-table {
    .headding {
        background: $ypo-dark-gray;
        color: $white;
        padding: 10px;
        text-transform: uppercase;
        font-weight: 600;
        align-items: center;
    }

    &__grid {
        &__body {
            max-height: 250px;
            overflow-y: auto;
            margin-top: 5px;
            margin-bottom: 10px;

            .layout {
                padding: 5px 0;
            }

            span {
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                display: block;
                padding: 0 5px;
            }

            a {
                padding: 0 10px;
                color: $ypo_cta;
                text-decoration: none;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                display: block;

                &:hover {
                    text-decoration: underline;
                }
            }
        }

        &.full {
            a {
                display: inline-block;
                margin-bottom: 7px;
            }
        }
    }

    &.chapter-reports {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;

        .see-more {
            padding: 15px 10px;
            background-color: $ypo-extra-light-gray;
            border-top: 1px $ypo-about-border solid;
            font-size: 10px;

            a {
                text-decoration: none;
                color: $ypo_cta;

                &:hover {
                    text-decoration: underline;
                }
            }
        }
    }
}

.manage-chapter {
  &--wrapper {
    margin-bottom: 30px;
  }

  &__title {
    font-family: 'Raleway', sans-serif;
    color: $ypo-blue;
    font-size: 18px;
    line-height: 34px;
    font-weight: 500;
    padding: 8px 15px;
    border-bottom: 1px solid $ypo-medium-gray
  }

  &__options {
    padding: 0 0 10px 15px;

    &--link {
      cursor: pointer;
      color: $ypo-cta;
      padding-top: 10px;
    }
  }
}
</style>
